<template>
  <section class="footer-edit modal-backdrop">
    <div class="modal-container standard-size">
      <!-- Header -->
      <div class="modal-container__header">
        <h2 class="h1">EDIT FOOTER</h2>
        <div style="cursor: pointer" @click="close()">
          <v-icon name="times" scale="2" />
        </div>
      </div>

      <!-- Visibility -->
      <div class="input-group add--display-flex">
        <h3 class="h2">Visible</h3>
        <label class="input-switch">
          <input type="checkbox" v-model="isVisible" />
          <span class="switch-button"></span>
        </label>
      </div>

      <!-- <div class="contentCard">
        <div class="headline">
          <h1>FOOTER VISIBILITY</h1>
        </div>
        <div class="flexSection editStylesSection">
          <h2>This box is visible for:</h2>
          <div class="visibility__body" v-on:click="editVisibility('all', visibility.anonymous && visibility.checkin &&  visibility.precheckin)">
            <p class="visibility__item">All guests</p>
            <img class="visibility__item" src="@/assets/EndOfLife/toggleEnabled.svg" alt="enabled" v-if="this.visibility.anonymous && this.visibility.checkin && this.visibility.precheckin">
            <img class="visibility__item" src="@/assets/EndOfLife/toggleDisabled.svg" alt="disabled" v-else-if="!(this.visibility.anonymous && this.visibility.checkin && this.visibility.precheckin)">
          </div>
          <div class="visibility__body" v-on:click="editVisibility(name,value)" v-bind:key="name" v-for="(value,name) in orderedArray">
            <p class="visibility__item">{{formatName(name)}}</p>
            <img class="visibility__item" src="@/assets/EndOfLife/toggleEnabled.svg" alt="enabled" v-if="value">
            <img class="visibility__item" src="@/assets/EndOfLife/toggleDisabled.svg" alt="disabled" v-else-if="!value">
          </div>
        </div> -->

      <!-- Image -->
      <div class="input-group">
        <h3 class="h2">Images</h3>
        <div>
          <button
            class="button-neutral add-button"
            @click="showImageModal = true"
          >
            Add New
          </button>
          <draggable
            v-model="imagePathArray"
            @start="drag = true"
            @end="drag = false"
            @sort="onSort(imagePathArray)"
          >
            <div
              v-for="(image, key) in imagePathArray"
              :key="key"
              class="drag-container"
            >
              <div class="drag-container__arrow-container add--cursor-move">
                <v-icon name="arrows-alt-v" scale="1.5" />
              </div>
              <div class="drag-container__image-container">
                <img :src="image" />
              </div>
              <div
                class="drag-container__close-container add--cursor-pointer"
                @click="deleteBtnClicked(key)"
              >
                <v-icon name="times" scale="1.5" />
              </div>
            </div>
          </draggable>
        </div>
      </div>

      <div class="button-container">
        <button class="button-neutral" @click="close()">Cancel</button>
        <button class="button-positive" @click="btnUpdate()">Update</button>
      </div>
    </div>
    <ImageManager
      v-if="showImageModal"
      :isModal="true"
      @changed="onSelectedImage"
      @close="showImageModal = false"
    />
    <approve-modal
      v-if="showReuseModal"
      @yes="closeWithYes()"
      @no="closeWithNo()"
    >
      <p slot="text">Are you sure to remove this image?</p>
    </approve-modal>
  </section>
</template>

<script>
import ImageManager from "@/components/MediaPage/MediaImages";
import ApproveModal from "@/components/GlobalComponents/ApproveModal";
import draggable from "vuedraggable";
import { db } from "@/firebase";

export default {
  components: {
    ImageManager,
    draggable,
    ApproveModal,
  },
  data() {
    return {
      showReuseModal: false,
      imagePathArray: [],
      showImageModal: false,
      imagePath: "a path",
      imageWaitForDeletion: "",
      isVisible: true,
      visibility: { precheckin: true, checkin: true, anonymous: true },
    };
  },
  // computed: {
  //   orderedArray: function () {
  //     let p = this.visibility.precheckin;
  //     let c = this.visibility.checkin;
  //     let a = this.visibility.anonymous;
  //     let orderedVisibility = {'precheckin': p, 'checkin': c ,'anonymous': a}
  //     return orderedVisibility;
  //   }
  // },
  firebase() {
    return {
      imageFooterArray: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/imageFooter/`),
        readyCallback: function (data) {
          if (data.val()) {
            this.imagePathArray = data.val();
          } else {
            this.imagePathArray = [];
          }
        },
      },
      returnedData: {
        source: db.ref(`hotels/${this.$customerId}/${this.$hotelId}/footerContent/`),
        asObject: true,
        readyCallback: function (data) {
          this.isVisible =
            data.val().visibility.precheckin &&
            data.val().visibility.checkin &&
            data.val().visibility.anonymous;
        },
      },
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    btnUpdate: function () {
      let footerContent = {
        visibility: {
          precheckin: this.isVisible,
          checkin: this.isVisible,
          anonymous: this.isVisible,
        },
      };
      // let footerContent = {
      //   isVisible: this.isVisible,
      // }

      // Update image array
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/imageFooter/`).set(
        this.imagePathArray
      );

      // Update visibility
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/footerContent/`)
        .update(footerContent)
        .then(() => {
          this.$toastEvents.push({
            type: "positive",
            title: "Success",
            content: "The footer has been updated",
            id: +new Date(),
          });
          this.$emit("close");
        });
    },
    deleteBtnClicked: function (key) {
      this.imageWaitForDeletion = key;
      this.showReuseModal = true;
    },
    closeWithYes: function () {
      this.showReuseModal = false;
      this.deleteImage(this.imageWaitForDeletion);
    },
    closeWithNo: function () {
      this.showReuseModal = false;
      this.imageWaitForDeletion = "";
    },
    onSort: function (updatedData) {
      db.ref(`hotels/${this.$customerId}/${this.$hotelId}/imageFooter/`).set(updatedData);
    },
    deleteImage(key) {
      // TODO - this should not be checked here, but instead on SAVE. User should be able to remove all images but not save without images
      if (this.imagePathArray.length == 1) {
        this.$toastEvents.push({
          type: "copy",
          title: "Footer",
          content: "At least one image is needed",
          id: +new Date(),
        });
      } else {
        this.imagePathArray.splice(key, 1);
        db.ref(`hotels/${this.$customerId}/${this.$hotelId}/imageFooter/`).set(
          this.imagePathArray
        );
        this.imageWaitForDeletion = "";
        this.$toastEvents.push({
          type: "copy",
          title: "Footer",
          content: "Image has been removed",
          id: +new Date(),
        });
      }
    },
    toggleVisiblity() {
      this.isVisible = !this.isVisible;
    },
    // editVisibility(name, value) {
    //   if (name == 'all') {
    //     this.visibility = this.visibility.anonymous && this.visibility.checkin &&  this.visibility.precheckin ? {'precheckin': false, 'checkin': false ,'anonymous': false} : {'precheckin': true, 'checkin': true, 'anonymous': true};
    //     this.$emit('editVisibility', this.visibility);
    //   } else {
    //     this.visibility[name] = !value;
    //     this.$emit('editVisibility', this.visibility);
    //   }
    // },
    // formatName: function (name) {
    //   let computed = '';
    //     switch(name) {
    //     case 'precheckin':
    //       computed = 'Prechecked-in guests'
    //     break;
    //     case 'checkin':
    //       computed = 'Checked-in guests'
    //     break;
    //     case 'anonymous':
    //       computed = 'Guests from QR Code'
    //     break;
    //   }
    //   return computed;
    // },
    onSelectedImage(imageUrl) {
      this.imagePathArray.push(imageUrl);
    },
  },
};
</script>

<style scoped>
.input-group .h2 {
  margin-top: 24px;
  margin-bottom: 16px;
}

.input-switch {
  margin-top: 8px;
  margin-left: 48px;
}

.drag-container {
  display: flex;
  color: var(--grey);
  margin-bottom: 44px;
}

.drag-container__arrow-container,
.drag-container__close-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.drag-container__image-container {
  width: 340px;
  height: 120px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  background-color: var(--grey-light);
  border-radius: var(--border-radius);
}

.drag-container__image-container img {
  width: 100%;
  border-radius: var(--border-radius);
  object-fit: contain;
}

.add-button {
  margin-bottom: 24px;
}

/* <div class="drag-container__arrow-container"><v-icon name="arrows-alt-v" scale="1.5"/></div>
<div class="drag-container__image-container"><img :src="image"></div>
<div class="drag-container__close-container" @click="deleteBtnClicked(key)"><v-icon name="times" scale="1.5"/></div> */

/* * {
  box-sizing: border-box;
}
h1, h2, h3, h4, p {
  color: #707070;
  font-size: 16px;
}
h1 {
  font-size: 32px;
  font-weight: 100;
  text-align: center;
}
h2 {
  font-size: 24px;
  font-weight: 100;
}
.contentCard {
  width: 100vw;
  margin: 25px auto;
  display: flex;
  flex-direction: column;
  max-width: 1100px;
}
.headline {
  border-bottom: 1px solid #707070;
  margin-bottom: 20px;
  padding-top: 10px;
}
.flexSection {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.editStylesSection {
  position: relative;
}
.btnWrapper {
  margin: 20px 0;
  display: flex;
  justify-content: center;
}
.visibility__item {
  margin-bottom: 5px;
}


.outerWrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #707070;
  background-color: #FFFFFF;
  padding: 7px;
  margin-bottom: 25px;
  height: 80px;
}
.imgWrap {
  display: inline-block;
  height: 100%;
}
.imgWrap img {
  height: 100%;
}

@media screen and (max-width: 1438px) {
  .contentCard {
    width: 100vw;
    padding: 0 20px;
  }
  .flexSection {
    display: flex;
    flex-direction: column;
  }
  .editStylesSection > p {
    text-align: center;
    width: 100%;
  }
} */
</style>
